import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import CustomDialog from 'app/components/ui/Dialog/Dialog';

const ConfirmationDialog = ({
  open,
  title,
  confirmText,
  canceltext,
  handleClose,
  handleConfirm,
  confirmTextColor = 'error',
  isLoadingGetTransferDetails,
}: {
  open: boolean;
  title: string;
  confirmText: string;
  canceltext?: string;
  confirmTextColor?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  handleClose: () => void;
  handleConfirm: () => void;
  isLoadingGetTransferDetails? : boolean;
}) => {
  const { t } = useTranslation();
  const defaultCancelText = canceltext || t('commonActions.close');

  return (
    <CustomDialog closeIcon={false} open={open} handleClose={handleClose}>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px',
          gap: '16px',
        }}
      >
        <img src="/images/alert.svg" alt="alert" width="64" height="64" />
        <Typography textAlign="center" fontWeight={400} fontSize={20}>
          {title}
        </Typography>
        <Typography fontWeight={700} fontSize={20}>
          {t('commonActions.areYouSure')}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: '0px !important',
        }}
      >
        <Button disabled={isLoadingGetTransferDetails} color={confirmTextColor} onClick={handleConfirm}>
          {confirmText}
        </Button>
        <Button color={'secondary'} onClick={handleClose}>
          {defaultCancelText}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default ConfirmationDialog;
